import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { queryKeys } from '../constants';

export function useDeleteDashboard() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      const res = await $api.delete(`/v1/dashboard/${id}`);

      return res.data;
    },
    onSuccess: async res => {
      showMessage(res.message, true);

      await qc.invalidateQueries({
        queryKey: [queryKeys.DASHBOARD_ID]
      });
    },
    onError: baseErrorHandler
  });
}
